import { render, staticRenderFns } from "./SiestaHints.vue?vue&type=template&id=491a3045&scoped=true&"
import script from "./SiestaHints.vue?vue&type=script&lang=js&"
export * from "./SiestaHints.vue?vue&type=script&lang=js&"
import style0 from "./SiestaHints.vue?vue&type=style&index=0&id=491a3045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a3045",
  null
  
)

export default component.exports